import commonApi from './CommonApi.js';
import uploadApi from './UploadApi.js';

export default {
	getCRNNotificationNumber: async (parameter) => {
		return await commonApi().get('/v1/admin/crnNotifications/getCRNNotificationNumber', { params: parameter })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	retrieve: async (viewModel) => {
		return await commonApi().post('/v1/admin/crnNotifications/retrieveNotifications', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	publishToDMS: async (formData) => {
		return await uploadApi().post('/v1/admin/crnNotifications/publishToDMS',
			formData, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}